import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import image from "../../assets/Assets-V4/Switching/ecs-aggregation@2x.jpg";
import v3Image from "../../assets/Switching/enterpriseCampusAggregation.jpg";
import type { Product } from "../../types";
import { aggregation } from "../product-groups/switching/aggregation";
import { productListSwitchingEnterprise } from "../product-list-groups/productListSwitchingEnterprise";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const enterpriseCampusAggregation: Product = {
  id: "enterpriseCampusAggregation",
  productTitle: "Enterprise Campus Aggregation",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/ecs-aggregation`,
  ],
  storePathParts: {
    productSlug: "ecs-aggregation",
    category: UniFiChildCategorySlug.SwitchingAggregation,
  },
  sku: "ECS-Aggregation",
  description: "enterpriseCampusAggregation.description",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 230,
    height: 120,
  },
  productListGroup: productListSwitchingEnterprise,
  productGroup: aggregation,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442.4 x 43.7 x 496 mm\n(17.4 x 1.7 x 19.5")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "54" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "25 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "100 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "enterpriseCampusAggregation.generalRedundancy",
      },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
